import React from 'react'
import { Actions } from 'src/components/CustomTable/components/Actions'
import { IAnimal } from 'src/dto/animal.dto'
import { SaleDTO } from 'src/dto/sale'
import { formatDate } from 'src/utils'

interface IUseSalesTableHeader {
  handleItemDetailModal: (item: SaleDTO | undefined | null) => void
}
export const useSalesTableHeader = ({ handleItemDetailModal }: IUseSalesTableHeader) => {
  const tableHeader = [
    {
      property: 'data',
      name: 'DATA',
      format: (date: string) => formatDate(date, false) || '-',
      textAlign: 'center'
    },
    {
      property: 'animalList',
      name: 'ANIMAL',
      textAlign: 'center',
      format: (animalList: IAnimal[]) =>
        animalList?.length ? animalList.map((animal) => (animal.nome ? animal.nome : '"Sem nome"')).join(',  ') : '-'
    },
    {
      property: 'valorTotal',
      name: 'PREÇO',
      textAlign: 'center',
      format: (value: number | string) => {
        if (!value) return '-'
        const v = typeof value === 'number' ? value : parseFloat(value)
        return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      }
    },
    {
      property: 'comprador',
      name: 'COMPRADOR',
      textAlign: 'center',
      format: (value: string) => value || '-'
    },
    {
      size: 122,
      property: 'status',
      compoment: (value: SaleDTO) => <Actions onClick={() => handleItemDetailModal(value)} />
    }
  ]

  return {
    tableHeader
  }
}
